<template>
  <div class="container">
    <v-expansion-panels>
      <v-expansion-panel>
        <v-expansion-panel-header>
            Φίλτρα αναζήτησης
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-row>
            <v-col cols="12" sm="6">
              <v-menu
                  v-model="menu1"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="auto">
                  <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                          v-model="documentIssueDateStartFilter"
                          label="Ημερομηνία έκδοσης (Από)"
                          append-icon="mdi-calendar"
                          readonly
                          v-bind="attrs"
                          v-on="on"
                          clearable>
                      </v-text-field>
                  </template>
                  <v-date-picker
                      v-model="documentIssueDateStartFilter"
                      @input="menu1 = false">
                  </v-date-picker>
              </v-menu>
            </v-col>

            <v-col cols="12" sm="6">
                <v-menu
                    v-model="menu2"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="auto">
                    <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                            v-model="documentIssueDateStopFilter"
                            label="Ημερομηνία έκδοσης (Έως)"
                            append-icon="mdi-calendar"
                            readonly
                            v-bind="attrs"
                            v-on="on"
                            clearable>
                        </v-text-field>
                    </template>
                    <v-date-picker
                        v-model="documentIssueDateStopFilter"
                        @input="menu2 = false">
                    </v-date-picker>
                </v-menu>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="12" sm="6">
                <v-select 
                    v-bind:items="warehouses" 
                    v-model="departureWarehouseFilter"
                    return-object
                    
                    item-text="description" 
                    label="Αποθήκη αποστολής"
                    clearable>
                </v-select>
            </v-col>

            <v-col cols="12" sm="6">
                <v-select 
                    v-bind:items="warehouses" 
                    v-model="arrivalWarehouseFilter"
                    return-object
                    
                    item-text="description" 
                    label="Αποθήκη παραλαβής"
                    clearable>
                </v-select>
            </v-col>
        </v-row>

          <v-row>
            <v-col cols="12" sm="6">
                <v-select 
                    v-bind:items="documentTypes" 
                    v-model="documentTypeFilter"
                    return-object
                    
                    item-text="description" 
                    label="Είδος παραστατικού"
                    clearable>
                </v-select>
            </v-col>
        </v-row>

          <v-row class="my-2" cols="12" align="center" justify="center">
            <v-btn 
                class="mx-2"
                color="success" 
                @click="getData" 
                v-bind:loading="getDataButtonDisabled"
                style="width:120px;">
                <span class="text-truncate" style="width:100px;">ΑΝΑΖΗΤΗΣΗ</span>
            </v-btn>

            <v-btn 
                class="mx-2"
                color="warning" 
                @click="clearFilters" 
                style="width:120px;">
                <span class="text-truncate" style="width:100px;">ΚΑΘΑΡΙΣΜΑ</span>
            </v-btn>

        </v-row>
      </v-expansion-panel-content>
    </v-expansion-panel>
  </v-expansion-panels>

    <v-data-table
      :headers="headers"
      :items="items"
      :sort-by="['issue_date']"
      :sort-desc="true"
      class="elevation-1 my-2"
      disable-pagination
      disable-filtering
      hide-default-footer
      v-model="selectedRows"
      v-bind:show-select="incomingStanding">
      
      <template v-slot:top>
        <v-toolbar flat>
          <v-toolbar-title>Παραστατικά ενδοδιακίνησης</v-toolbar-title>
          <v-divider class="mx-4" inset vertical></v-divider>
          <div class="mt-8">
            <!-- <v-radio-group v-model="radioGroup1" row>
              <v-radio label="Αποστολές" value="1" />
              <v-radio label="Εισερχόμενα" value="2" />
            </v-radio-group> -->

            <v-checkbox label="Αναμενόμενα" v-model="incomingStanding"></v-checkbox>
          </div>
          <v-spacer></v-spacer>
          <v-btn color="primary" dark class="m-2" @click="newDocumentButtonClicked">
            ΝΕΟ
          </v-btn>
          <v-btn color="success" dark class="m-2" @click="excelPlease" v-show="showExport" v-bind:loading="getExcelButtonDisabled">
            ΕΞΑΓΩΓΗ
          </v-btn>

          <v-btn color="warning" dark class="m-2" @click="acceptSelected" v-show="showAccept" v-bind:loading="acceptButtonDisabled">
            ΠΑΡΑΛΑΒΗ
          </v-btn>

          <v-dialog v-model="dialogDelete" max-width="500px">
            <v-card>
              <v-card-title class="text-h5">Διαγραφή εγγραφής {{editedItem.document}};</v-card-title>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary darken-1" text @click="closeDelete">ΑΚΥΡΟ</v-btn>
                <v-btn color="error darken-1" @click="deleteItemConfirm" v-bind:loading="deleteButtonDisabled">ΕΝΤΑΞΕΙ</v-btn>
                <v-spacer></v-spacer>
              </v-card-actions>
            </v-card>
          </v-dialog>

          <v-dialog v-model="dialogMail" max-width="500px">
            <v-card>
              <v-card-title class="text-h5">Αποστολή email</v-card-title>
              <v-card-text>
                <v-text-field 
                  v-model="editedItem.customer_email"
                  label="Διεύθυνση αποστολής">
                </v-text-field>
                <v-checkbox v-model="saveMailAddress" label="Αποθήκευση διεύθυνσης email"/>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary darken-1" text @click="closeMail">ΑΚΥΡΟ</v-btn>
                <v-btn color="success darken-1" @click="mailConfirm" v-bind:loading="mailButtonDisabled">ΕΝΤΑΞΕΙ</v-btn>
                <v-spacer></v-spacer>
              </v-card-actions>
            </v-card>
          </v-dialog>


        </v-toolbar>
      </template>
      
      <template v-slot:[`item.issue_date`]="{ item }">
        {{ formatDate(item.issue_date) }}
      </template>

      <template v-slot:[`item.actions`]="{ item }">
        <v-icon small color="primary" @click="sendMail(item)"> mdi-email </v-icon>
        <v-icon small color="primary" @click="show(item)"> mdi-printer </v-icon>
        <router-link :to="{name: 'editservicedocument', params: {id: item.id}}" v-if="false"> 	
          <v-icon small class="mr-2"> mdi-pencil </v-icon>
        </router-link>
        <v-icon v-if="incomingStanding == false" small color="error" @click="deleteItem(item)"> mdi-delete </v-icon>
      </template>
    </v-data-table>
  </div>
</template>

<script>
  import moment from "moment";

  export default {
    data: () => ({

      editedItem: {},
      dialog: false,
      dialogDelete: false,
      dialogMail: false,

      saveMailAddress: false,

      deleteButtonDisabled: false,
      mailButtonDisabled: false,

      headers: [
        { 
            text: 'Actions',
            align: 'center', 
            value: 'actions', 
            sortable: false,
            exportable: false
        },
        {
          text: 'Ημερομηνία',
          align: 'start',
          value: 'issue_date',
          exportTransformer: (cell) => moment(cell).format("DD/MM/YYYY")
        },

        { 
          text: 'Παραστατικό', 
          align: 'center',
          value: 'document' 
        },

        {
          text: 'Έκδοση',
          align: 'center',
          value: 'issuer_warehouse',
        },

        { 
          text: 'Από/προς', 
          align: 'center',
          value: 'related_warehouse',
        },

        { 
          text: 'Τεμάχια', 
          align: 'center',
          value: 'total_quantity',
        },
        
      ],

      allItems: [],

      documentTypes: [],

      documentTypeFilter: null,

      documentIssueDateStartFilter: null,
      documentIssueDateStopFilter: null,

      arrivalWarehouseFilter: null,
      departureWarehouseFilter: null,

      getDataButtonDisabled: false,
      getExcelButtonDisabled: false,

      acceptButtonDisabled: false,

      menu2: null,
      menu1: null,

      warehouses: [],


      radioGroup1: 1,
      incomingStanding: false,

      // userWarehouseIds: []
      selectedRows: []

    }),

    watch: {
      dialog (val) {
        val || this.close()
      },
      dialogDelete (val) {
        val || this.closeDelete()
      },
    },

    created () {
      this.initialize()
    },

    computed: {
      showAccept() {
        return this.incomingStanding && this.selectedRows.length > 0
      },

      userWarehouseIds() {
        const userBranchId = this.$store.state.currentUser.user.branch_id
        
        return this.warehouses.filter(x => x.branch_id == userBranchId).map(x => x.id)
      },

      items() 
      {
        const userBranchId = this.$store.state.currentUser.user.branch_id
        if (userBranchId == null)
          return this.allItems
        
        switch (this.incomingStanding)
        {
          case false:
            return this.allItems.filter(x => this.userWarehouseIds.includes(x.warehouse_id));

          case true:
            return this.allItems.filter(x => x.debit == true && x.credit == false && this.userWarehouseIds.includes(x.related_warehouse_id))
        }
      },

      showExport() {
        return this.items?.length > 0
      },

      totalQuantity() {
        return this.items?.length ?? 0
      }
    },

    methods: {

      async acceptSelected() {
        this.acceptButtonDisabled = true

        //

        const delay = (delayInms) => {
          return new Promise(resolve => setTimeout(resolve, delayInms));
        };

        
        const txt = this.selectedRows.map(x => `<li>${x.document}</li>`)

        this.$swal.fire({
          html: `<div> Αποδοχή των δελτίων <ul>${txt}</ul></div>`,
          showCancelButton: true,
          confirmButtonText: 'ΕΝΤΑΞΕΙ',
          cancelButtonText: 'ΑΚΥΡΟ'
        }).then(async (result) => {
          /* Read more about isConfirmed, isDenied below */

          if (result.isConfirmed) {
            // send request

            axios
              .post('/api/documents/internal-shipping/from-incoming', { 
                selected_document_ids: this.selectedRows.map(x => x.id), 
                warehouse_id: this.selectedRows[0].related_warehouse_id,
                related_warehouse_id: this.selectedRows[0].warehouse_id 
              })
              .then(_ => { this.$swal.fire("Saved!", "", "success").then(this.getData()); })
              .catch(error => { console.log(error) })
          }
        }).finally(() => { this.acceptButtonDisabled = false });

        

        
      },

      excelPlease() {
        if (this.items?.length > 0 == false) {
          console.log('No items!')
          return
        }

        const transform = (line, columnDefinitions) => {
          let out = []

          columnDefinitions.forEach(columnDefinition => {

            const columnValue = line[columnDefinition.propertyName]

            if (columnDefinition.exportTransformer)
              out.push(columnDefinition.exportTransformer(columnValue))
            else
              out.push(columnValue)
          });

          return out;
        }

        const exportableColumns = this.headers.filter(x => (x.exportable ?? true) == true)
        const columnDefinitions = exportableColumns.map(x => ({ propertyName: x.value, exportTransformer: x.exportTransformer }))

        const requestBody = {
          table_headers: exportableColumns.map(x => x.text),
          table_entries: this.items.map(line => transform(line, columnDefinitions))
        }

        this.axiosDownload('/api/test', requestBody, 'αναφορά.xls')
      },

      axiosDownload(url, requestBody, filename) {
        this.getExcelButtonDisabled = true;

        axios({
            url: url, 
            data: requestBody,
            method: 'POST',
            responseType: 'blob', // important
        }).then((response) => {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', filename); //or any other extension
            document.body.appendChild(link);
            link.click();
            this.getExcelButtonDisabled = false
        // link.remove();
        // url.remove();

        }).catch(err => { console.log(err); this.getExcelButtonDisabled = false})
      },

      newDocumentButtonClicked() {
        this.$router.push({ name: 'newinternalshippingdocument' })
      },

      formatDate(value) {
        return moment(value).format("DD/MM/YYYY")
      },

      initialize () {
        this.$store.dispatch('currentUser/getCurrentUser')
        
        const initialDaysBeforeFilterValue = 30

        const today = new Date();

        let filterStart = new Date()
        filterStart.setDate(today.getDate() - initialDaysBeforeFilterValue);

        this.documentIssueDateStartFilter = this.$localDateString(filterStart)
        // this.documentIssueDateStopFilter = today.toISOString().split('T')[0]

        this.getData();
        this.getFilterValues()
      },

      getFilterValues() {
        axios.get('/api/document-types/internal-shipping')
        .then(response => this.documentTypes = response.data)


        axios.get('/api/warehouses')
        .then(response => {
          this.warehouses = response.data

          // this.userWarehouseIds = this.warehouses.filter(x => x.branch_id == this.$store.state.currentUser.user.branch_id).map(x => x.id)
      })

      },
      
      getRequestParams() {
        return {
              issue_date_start: this.documentIssueDateStartFilter,
              issue_date_stop: this.documentIssueDateStopFilter,
              document_type_id: this.documentTypeFilter?.id,
              customer_id: this.customer?.id
          }

      },

      getData() {

        this.getDataButtonDisabled = true;
        axios.get(
            '/api/documents/internal-shipping/grid', 
            {
                params: this.getRequestParams()
            }
        )
        .then(response => this.allItems = response.data)
        .finally(() => { this.getDataButtonDisabled = false; })
        .catch(error => { console.log(error) })
        
      },

      editItem (item) {
        // this.editedIndex = this.items.indexOf(item)
        // this.editedItem = Object.assign({}, item)
        // this.dialog = true
      },

      deleteItem (item) {
        this.editedIndex = this.items.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.dialogDelete = true
      },

      deleteItemConfirm () {
        this.deleteButtonDisabled = true
        axios.delete(`/api/documents/internal-shipping/${this.items[this.editedIndex].id}`)
        .then(response => { this.items.splice(this.editedIndex, 1); this.closeDelete(); })
        .catch(error => console.log(error))
        .finally(() => this.deleteButtonDisabled = false)
      },

      mailConfirm() {
        this.mailButtonDisabled = true
        axios
          .post('/api/mailer/internal-shipping', { document_id: this.editedItem.id, email_address: this.editedItem.customer_email, save_email: this.saveMailAddress ? true : false })
          .then(response => { console.log(response); this.closeMail(); })
          .catch(error => { console.log(error) })
          .finally(() => { this.mailButtonDisabled = false })
      },

      closeDelete () {
        this.dialogDelete = false
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
      },


      sendMail(item) {
        this.editedItem = Object.assign({}, item)
        this.dialogMail = true
      },

      show(item) {
        window.open(`/internalshippingdocuments/pdf/${item.uuid}`, '_blank').focus();
      },


      closeMail() {
        this.editedItem = {};
        this.dialogMail = false;
      },

    clearFilters() {
        this.customer = {}
        this.documentIssueDateStartFilter = null
        this.documentIssueDateStopFilter = null
        this.documentTypeFilter = null
    }
  }
}
</script>

<style scoped>
</style>